function enhanceRdnButtons() {
  const isRdn = document.body.classList.contains('rdn');
  if (!isRdn) return;

  const buttons = document.querySelectorAll(
    '.body-copy a.button-primary, .body-copy a.button-secondary'
  );

  if (!buttons.length) return;

  buttons.forEach((btn) => {
    if (btn.dataset.rdnProcessed) return;

    const title = btn.textContent.trim();
    const href = btn.getAttribute('href');
    const type = btn.classList.contains('button-primary')
      ? 'button-primary'
      : 'button-secondary';

    const newBtn = document.createElement('a');
    newBtn.className = `${type} not-ext-link`;
    newBtn.href = href;
    newBtn.setAttribute('aria-label', `link to ${title}`);

    const icon = document.createElement('span');
    icon.className = 'arrow-icon';

    const text = document.createElement('span');
    text.textContent = title;

    newBtn.appendChild(icon);
    newBtn.appendChild(text);

    btn.replaceWith(newBtn);

    newBtn.dataset.rdnProcessed = 'true';
  });
}

document.addEventListener('DOMContentLoaded', enhanceRdnButtons);